<template>
    <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex xs12>
                <v-img class="bgImage" src="/static/serviceBg.jpg" max-height="380px"></v-img>
            </v-flex>
            <v-flex xs12>
                <v-card flat>
                    <v-card-title>
                        <h2>Timely and Efficiently Services</h2>
                    </v-card-title>
                    <v-card-text class="px-0">
                        <blockquote>
                            <p align="left">
                                “At Prudent, our services go beyond traditional tax and insurance to include a
                                comprehensive
                                set of one-stop services. We follow a team approach,
                                finalize works step by step, and we sincerely invite you to learn more about how Prudent
                                can
                                help you.”
                            </p>
                            <p align="right">— Prudent CPA & Prudent Brokerage</p>
                        </blockquote>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-divider dark></v-divider>
            <v-flex xs12 lg6 pa-0 ma-0>
                <v-card flat>
                    <v-card-title>
                        <h2>Individual Tax Services:</h2>
                    </v-card-title>
                    <v-card-text class="px-0">
                        <ul v-for="(service, i) in IndServices" :key="i">
                            <li align="left">{{service}}</li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 lg6 pa-0 ma-0>
                <v-card flat>
                    <v-card-title>
                        <h2>Individual Clients:</h2>
                    </v-card-title>
                    <v-img class="px-0" src="static/indClientPrediction.png" fill-height></v-img>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card flat>
                    <v-card-text class="px-0 text-align-left">
                        <p align="left">
                            We are more than proud of the rapid growth in our Individual Tax Services sector. We had
                            less
                            than 1,000 individual clients in the first year of our business, but this year we have
                            successfully served more than 3,000 individual clients in our second year of business, and
                            there
                            is no surprise that we expect we will have around 5,000 individual clients in our third year
                            of
                            our business.
                        </p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 lg6 pa-0 ma-0>
                <v-card flat>
                    <v-card-title>
                        <h2>Corporation Tax Services:</h2>
                    </v-card-title>
                    <v-card-text class="px-0">
                        <ul v-for="(service, i) in BizServices" :key="i">
                            <li align="left">{{service}}</li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 lg6 pa-0 ma-0>
                <v-card flat>
                    <v-card-title>
                        <h2>IBusiness Clients:</h2>
                    </v-card-title>
                    <v-img class="px-0" src="static/bizClientPrediction.png"></v-img>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card flat>
                    <v-card-text class="px-0 text-align-left">
                        <p align="left">
                            Our Corporate Tax Services sector has made tremendous expansion on business clients base. In
                            2014, we had only a few business clients, but in 2015 we have successfully increased our
                            client base from single digit to three digits, from 10 to 300. And we have no doubt that in
                            the coming year we will have more than 1,000 business clients.`
                        </p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 lg6 pa-0 ma-0>
                <v-card flat>
                    <v-card-title>
                        <h2>Insurance Services:</h2>
                    </v-card-title>
                    <v-card-text class="px-0">
                        <ul v-for="(service, i) in InsurServices" :key="i">
                            <li align="left">{{service}}</li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "ServiceHome",
        data: () => ({
            IndServices: [
                'Individual 1040 Tax Return',
                '1040NR Non-Resident Aliens Tax Return (F1; J1; H1B)',
                'Tax ID (ITIN) Application',
                'Tax Refund Status Query',
                'Foreign Account Reporting (FATCA)',
                'Tax Transcript Request',
                'Estate and Gift Planning',
                'Intertwine Business and Personal Taxes',
                'All 50 States and Overseas Income Taxes Service'
            ],
            BizServices: [
                'Incorporation & Dissolution (INC, LLC, NON-PROFIT)',
                'New Business Consulting and Compliance',
                'EIN Registration',
                'Tax & Accounting Assistance',
                'Preparation, Compilation, Review, and Audit of Financial Statements',
                'Payroll Tax Services',
                'Property Tax Return Preparation',
                'Sales and Use Tax (50 States & Local)',
                'Hospitality Accounting',
                'Real Estate Accounting',
                'Outsourced Accounting Solutions',
                'Bookkeeping',
                'Licenses Registration'
            ],
            InsurServices: [
                'Homeowner',
                'Auto',
                'Commercial',
                'TLC',
                'Worker\'s Compensation',
                'Disability',
                'Contractors and all other types of insurances'
            ]
        })
    }
</script>

<style scoped>
    .container {
        background-color: white;
    }
    .v-card__title{
        color: #ffcf5d;
    }
</style>


// WEBPACK FOOTER //
// src/components/service/ServiceHome.vue